"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'PermissionList',
  data: function data() {
    return {
      filterText: '',
      // 搜索框（左树子表）的值
      permissionMenu: [],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    };
  },
  watch: {
    filterText: function filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  mounted: function mounted(options) {
    this.getPermissionMenu();
  },
  methods: {
    filterNode: function filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    /**
     * 获取权限目录
     */
    getPermissionMenu: function getPermissionMenu() {
      var _this = this;
      var url = 'agentapi/menu';
      this.$get(url).then(function (res) {
        _this.permissionMenu = res;
      });
    }
  }
};